module.exports = __webpack_public_path__ + "static/media/alphafold2.b3f7339e.jpg";